export const localStorageKeys = {
  language: 'language' as const,
};
